import axios from "axios";

const serverBaseUrl = process.env.REACT_APP_API_BASE || "";

const Interceptor = axios.create({
  baseURL: serverBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

async function getAuthToken() {
  return localStorage.getItem("token");
}

Interceptor.interceptors.request.use(
  async (config) => {
    try {
      const token = await getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      // Send the active organization context with every request
      const orgId = localStorage.getItem("currentOrgId");
      if (orgId) {
        config.headers["X-Org-Id"] = orgId;
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

Interceptor.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.code;

    // Handle token expiry - auto logout
    if (status === 401 && errorCode === "TOKEN_EXPIRED") {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return Promise.reject(error);
    }

    // Handle email not verified — provide clear message
    if (status === 403 && errorCode === "EMAIL_NOT_VERIFIED") {
      error.message =
        "Please verify your email address before performing this action.";
      return Promise.reject(error);
    }

    // Handle rate limiting - provide user-friendly error
    if (status === 429) {
      const retryAfter = error.response?.headers?.["retry-after"];
      error.message = retryAfter
        ? `Server is busy. Please try again in ${retryAfter} seconds.`
        : "Server is busy. Please wait a moment and try again.";
    }

    return Promise.reject(error);
  },
);

export default Interceptor;
